export const PROFILE_ACTION = {
    RESET_PROFILE_STATE: 'RESET_PROFILE_STATE',
    REQUEST_PROFILE: 'REQUEST_PROFILE',
    PROFILE_ERROR: 'PROFILE_ERROR',
    PROFILE_RESPONSE: 'PROFILE_RESPONSE',

    RESET_UPDATE_PROFILE_FOR_USER:'RESET_UPDATE_PROFILE_FOR_USER',
    REQUEST_UPDATE_PROFILE_FOR_USER:'REQUESTUPDATE_PROFILE_FOR_USER',
    RESPONSE_UPDATE_PROFILE_FOR_USER:'RESPONSE_UPDATE_PROFILE_FOR_USER',
    ERROR_UPDATE_PROFILE_FOR_USER:'ERROR_UPDATE_PROFILE_FOR_USER',

    RESET_UPLOAD_PROFILE_PICTURE: 'RESET_UPLOAD_PROFILE_PICTURE',
    REQUEST_UPLOAD_PROFILE_PICTURE: 'REQUEST_UPLOAD_PROFILE_PICTURE',
    RESPONSE_UPLOAD_PROFILE_PICTURE: 'RESPONSE_UPLOAD_PROFILE_PICTURE',
    ERROR_UPLOAD_PROFILE_PICTURE: 'ERROR_UPLOAD_PROFILE_PICTURE',

    RESET_GET_PROFILE_PICTURE:"RESET_GET_PROFILE_PICTURE",
  REQUEST_GET_PROFILE_PICTURE:"REQUEST_GET_PROFILE_PICTURE",
  RESPONSE_GET_PROFILE_PICTURE:"RESPONSE_GET_PROFILE_PICTURE",
  ERROR_GET_PROFILE_PICTURE:"ERROR_GET_PROFILE_PICTURE",
  
  RESET_UPLOAD_COVER_IMAGE:"RESET_UPLOAD_COVER_IMAGE",
  REQUEST_UPLOAD_COVER_IMAGE:"REQUEST_UPLOAD_COVER_IMAGE",
  RESPONSE_UPLOAD_COVER_IMAGE:"RESPONSE_UPLOAD_COVER_IMAGE",
  ERROR_UPLOAD_COVER_IMAGE:"ERROR_UPLOAD_COVER_IMAGE",

  RESET_GET_COVER_IMAGE:"RESET_GET_COVER_IMAGE",
  REQUEST_GET_COVER_IMAGE:"REQUEST_GET_COVER_IMAGE",
  RESPONSE_GET_COVER_IMAGE:"RESPONSE_GET_COVER_IMAGE",
  ERROR_GET_COVER_IMAGE:"ERROR_GET_COVER_IMAGE",
  };

  export const setResetStatePROFILE = () => ({
    type: PROFILE_ACTION.RESET_PROFILE_STATE,
    data: undefined
  });
  
  export const requestProfileAction = (params) =>({
    type:PROFILE_ACTION.REQUEST_PROFILE,
    data: params
  })
  export const responseProfileAction = (res) => ({
    type: PROFILE_ACTION.PROFILE_RESPONSE,
    data: res
  });
  
  export const errorProfileAction = (err) => ({
    type: PROFILE_ACTION.PROFILE_ERROR,
    data: err
  });
  
  export const setResetUpdateProfiileForUser = () => ({
    type: PROFILE_ACTION.RESET_UPDATE_PROFILE_FOR_USER,
    data: undefined
  });
  
  export const requestUpdateProfileForUser = (params) =>({
    type:PROFILE_ACTION.REQUEST_UPDATE_PROFILE_FOR_USER,
    data: params
  })
  export const responseUpdateProfileForUser = (res) => ({
    type: PROFILE_ACTION.RESPONSE_UPDATE_PROFILE_FOR_USER,
    data: res
  });
  
  export const errorUpdateProfileForUser = (err) => ({
    type: PROFILE_ACTION.ERROR_UPDATE_PROFILE_FOR_USER,
    data: err
  });

 export const setResetUploadProfilePicture = () => ({
    type: PROFILE_ACTION.RESET_UPLOAD_PROFILE_PICTURE,
    data: undefined
  });
  
  export const requestUploadProfilePicture = (params) =>({
    type:PROFILE_ACTION.REQUEST_UPLOAD_PROFILE_PICTURE,
    data: params
  })
  export const responseUploadProfilePicture = (res) => ({
    type: PROFILE_ACTION.RESPONSE_UPLOAD_PROFILE_PICTURE,
    data: res
  });
  
  export const errorUploadProfilePicture = (err) => ({
    type: PROFILE_ACTION.ERROR_UPLOAD_PROFILE_PICTURE,
    data: err
  });

  export const setResetGetProfilePicture =() =>({
    type:PROFILE_ACTION.RESET_GET_PROFILE_PICTURE,
    data :undefined
   });
   export const requestGetProfilePicture =(params) =>({
    type:PROFILE_ACTION.REQUEST_GET_PROFILE_PICTURE,
    data:params
   });
   export const responseGetProfilePicture = (res) =>({
    type:PROFILE_ACTION.RESPONSE_GET_PROFILE_PICTURE,
    data:res
   });
   export const errorGetProfilePicture = (err) =>({
    type:PROFILE_ACTION.ERROR_GET_PROFILE_PICTURE,
    data:err
   });

   export const setResetUploadCoverImage =() =>({
    type:PROFILE_ACTION.RESET_UPLOAD_COVER_IMAGE,
    data :undefined
   });
   export const requestUploadCoverImage =(params) =>({
    type:PROFILE_ACTION.REQUEST_UPLOAD_COVER_IMAGE,
    data:params
   });
   export const responseUploadCoverImage = (res) =>({
    type:PROFILE_ACTION.RESPONSE_UPLOAD_COVER_IMAGE,
    data:res
   });
   export const errorUploadCoverImage = (err) =>({
    type:PROFILE_ACTION.ERROR_UPLOAD_COVER_IMAGE,
    data:err
   });

   export const setResetGetCoverImage =() =>({
    type:PROFILE_ACTION.RESET_GET_COVER_IMAGE,
    data :undefined
   });
   export const requestGetCoverImage =(params) =>({
    type:PROFILE_ACTION.REQUEST_GET_COVER_IMAGE,
    data:params
   });
    export const responseGetCoverImage = (res) =>({
    type:PROFILE_ACTION.RESPONSE_GET_COVER_IMAGE,
    data:res
   });
   export const errorGetCoverImage = (err) =>({
    type:PROFILE_ACTION.ERROR_GET_COVER_IMAGE,
    data:err
   });